import authReducer from "@funded-here-interface/common/src/features/auth/authSlice_Admin";

import BorbankSlice from "./features/merchant/bankSlice";
import bizBorSlice from "./features/merchant/biz";
import docBorrowerSlice from "./features/merchant/doc";
import BorrepSlice from "./features/merchant/rep";
import bankSlice from "./features/registration/bankSlice";
import bizSlice from "./features/registration/bizSlice";
import docSlice from "./features/registration/docSlice";
import repSlice from "./features/registration/repSlice";
import bulkSlice from "./features/sku/bulkSlice";

export const adminReducers = {
  auth: authReducer,
  biz: bizSlice,
  rep: repSlice,
  bank: bankSlice,
  doc: docSlice,
  bulk: bulkSlice,
  borBiz: bizBorSlice,
  BorBank: BorbankSlice,
  Borrep: BorrepSlice,
  bordoc: docBorrowerSlice,
};
